import { Link } from 'react-router-dom-v5-compat';

import ReportResultLayout from 'dashboard/components/ReportResult/ReportResultLayout';
import TableLayout, { TableTD, TableTH, TableTR } from 'dashboard/layouts/TableLayout';
import { ReportBusinessSocialMedia } from 'dashboard/models/report/business-social-media';
import Card from 'design-system/components/Card';

interface BusinessSocialMediaProps {
  report: ReportBusinessSocialMedia;
  multiCardFormat: boolean;
}

const ensureScheme = (url: string) => {
  if (url == null) {
    return null;
  }

  // Add href component if it doesn't exist already
  if (url.startsWith('http')) {
    return url;
  }

  return `https://${url}`;
};

const BusinessSocialMedia = ({ report, multiCardFormat = false }: BusinessSocialMediaProps) => {
  const {
    'twitter-url': twitterUrl,
    'facebook-url': facebookUrl,
    'linkedin-url': linkedinUrl,
    'linkedin-id': linkedinId,
  } = report.attributes;

  const content = (
    <>
      <Card.Title>Social Media Accounts</Card.Title>
      <TableLayout
        dataTest='social-media-accounts'
        isLoading={false}
        showHeader={true}
        isEmpty={false}
        nullState={null}
        headerTR={
          <>
            <TableTH data-test='social-media-accounts__platform-header'>Platform</TableTH>
            <TableTH data-test='social-media-accounts__url-header'>URL</TableTH>
            <TableTH data-test='social-media-accounts__id-header'>ID</TableTH>
          </>
        }
      >
        <TableTR
          data-test='social-media-accounts__row--twitter'
          id='social-media-accounts__row--twitter'
          key='twitter'
        >
          <TableTD>Twitter</TableTD>
          <TableTD>
            {/* @ts-expect-error [strict-migration] The following line is not strict; please fix! */}
            <Link target='_blank' rel='noreferrer' to={ensureScheme(twitterUrl)}>
              {twitterUrl}
            </Link>
          </TableTD>
          <TableTD>-</TableTD>
        </TableTR>
        <TableTR
          data-test='social-media-accounts__row--linkedin'
          id='social-media-accounts__row--linkedin'
          key='linkedin'
        >
          <TableTD>LinkedIn</TableTD>
          <TableTD>
            {/* @ts-expect-error [strict-migration] The following line is not strict; please fix! */}
            <Link target='_blank' rel='noreferrer' to={ensureScheme(linkedinUrl)}>
              {linkedinUrl}
            </Link>
          </TableTD>
          <TableTD>{linkedinId}</TableTD>
        </TableTR>
        <TableTR
          data-test='social-media-accounts__row--facebook'
          id='social-media-accounts__row--facebook'
          key='facebook'
        >
          <TableTD>Facebook</TableTD>
          <TableTD>
            {/* @ts-expect-error [strict-migration] The following line is not strict; please fix! */}
            <Link target='_blank' rel='noreferrer' to={ensureScheme(facebookUrl)}>
              {facebookUrl}
            </Link>
          </TableTD>
          <TableTD>-</TableTD>
        </TableTR>
      </TableLayout>
    </>
  );

  return <ReportResultLayout multiCardFormat={multiCardFormat}>{content}</ReportResultLayout>;
};

export default BusinessSocialMedia;
